import Head from 'next/head';

import {
  renderJsonLdScript,
  Breadcrumb,
  getBreadcrumbStructuredData,
} from 'libs/universal/structuredData';

import { SubtopicType, TopicType } from 'libs/contentful/types';

import { ZOLA_DOMAIN } from 'constants/url';
import { EXPERT_ADVICE_META_IMAGE } from 'constants/expertAdvice';

type ExpertAdviceHeaderProps = {
  topic: TopicType | SubtopicType;
  breadcrumbs: Breadcrumb[];
  canonical: string;
};

const ExpertAdviceHeader: React.FC<ExpertAdviceHeaderProps> = ({
  topic: { name, description },
  breadcrumbs,
  canonical,
}) => {
  const metaTitle = `${name} - Zola Expert Wedding Advice`;
  const fullUrl = `${ZOLA_DOMAIN}${canonical}`;
  return (
    <Head>
      <title>{metaTitle}</title>
      <meta name="description" content={description} />
      <meta
        name="copyright"
        content={`© ${new Date().getFullYear()} Zola, Inc. All rights reserved.`}
      />

      {/* Open Graph */}
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={EXPERT_ADVICE_META_IMAGE} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:site_name" content="zola.com" />
      <meta property="og:phone_number" content="1-408-657-ZOLA" />
      <meta property="fb:app_id" content="215495315286955" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@zola" />
      <meta name="twitter:creator" content="@zola" />

      {/* Links */}
      <link rel="canonical" href={fullUrl} />

      {/* Schema.org */}
      {renderJsonLdScript(getBreadcrumbStructuredData(breadcrumbs))}
    </Head>
  );
};

export default ExpertAdviceHeader;
